import React from "react";
import { Box } from "@chakra-ui/react";

export function SyncIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 32 32" fill="none">
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.91463 18.8582C7.08937 17.5788 9.8593 18.348 11.0995 20.5366C11.9338 22.0091 11.8709 23.7636 11.0735 25.1382C12.4849 26.1082 14.1815 26.672 16.0071 26.672C16.5742 26.672 17.1286 26.618 17.6646 26.5145C18.3874 26.3751 19.0874 26.8478 19.2271 27.5705C19.3668 28.2934 18.8928 28.9932 18.1698 29.133C17.4686 29.2684 16.7452 29.3387 16.0071 29.3387C13.3994 29.3386 10.9951 28.4558 9.06698 26.9741C6.95998 27.9582 4.43467 27.1573 3.2662 25.0952C2.03449 22.921 2.75574 20.1291 4.91463 18.8582ZM8.77922 21.8517C8.26142 20.9381 7.1374 20.6446 6.2675 21.1564C5.38287 21.6771 5.06099 22.8522 5.58651 23.7801C6.10419 24.6938 7.22831 24.9869 8.09823 24.4754C8.98307 23.9548 9.30482 22.7798 8.77922 21.8517Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8235 9.79443C23.3482 9.34582 24.1211 9.37593 24.6099 9.84261L24.7037 9.94157L25.0253 10.3348C26.5924 12.3369 27.5279 14.8727 27.5279 17.6252C27.5279 18.1187 27.4941 18.6052 27.4355 19.0835C29.3228 20.4369 29.9022 23.0415 28.7389 25.0952C27.4986 27.2838 24.7287 28.0528 22.554 26.7736C20.3948 25.5029 19.6734 22.711 20.9055 20.5366L21.0266 20.3361C21.8827 18.9884 23.3408 18.2336 24.8404 18.2384C24.8536 18.0359 24.8612 17.8314 24.8612 17.6252C24.8612 15.4858 24.1367 13.5243 22.9264 11.978L22.6777 11.6746L22.5943 11.5666C22.209 11.0113 22.2989 10.2432 22.8235 9.79443ZM25.7376 21.1564C24.8675 20.6446 23.7436 20.9381 23.2258 21.8517C22.7001 22.7797 23.0218 23.9547 23.9068 24.4754C24.7767 24.987 25.9008 24.6939 26.4185 23.7801C26.9113 22.9099 26.6592 21.822 25.8964 21.2606L25.7376 21.1564Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M7.59693 14.7905C7.37083 15.491 6.61909 15.8755 5.91854 15.6499C5.21779 15.4239 4.83199 14.6723 5.05786 13.9715L7.59693 14.7905Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0071 2.66553C18.525 2.66557 20.5237 4.73972 20.524 7.24365C20.5237 9.74757 18.525 11.8217 16.0071 11.8218C14.3164 11.8218 12.8612 10.8855 12.0865 9.51318C9.98259 10.5779 8.34423 12.4736 7.59693 14.7905L5.05786 13.9715C6.0941 10.7588 8.46113 8.15261 11.5084 6.8374C11.7107 4.51912 13.6265 2.66554 16.0071 2.66553ZM16.0071 5.3335C15.0091 5.33351 14.1571 6.16486 14.1568 7.24365C14.1572 8.32243 15.0091 9.15509 16.0071 9.15511C17.0051 9.15507 17.857 8.32242 17.8573 7.24365C17.857 6.16488 17.0051 5.33354 16.0071 5.3335Z"
      />
    </Box>
  );
}
